import { Base } from "./Classes/base";
export class User extends Base {
    constructor(
        public id: number,
        public role: number,
        public email: string,
        public name: string,
        public password: string,
        public username: string

    ) {
        super();
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/_models/user.ts